import dayjs from 'dayjs';

export function normalizeWorkDate(workDate: string): string {
  return dayjs.utc(workDate).format('YYYY-MM-DD');
}

export function isPastWorkDate(workDate: string, now: dayjs.ConfigType = dayjs()): boolean {
  return dayjs(normalizeWorkDate(workDate)).isBefore(dayjs(now).startOf('day'));
}

export function getPastWorkDates(workDates: string[], now: dayjs.ConfigType = dayjs()): string[] {
  const seen = new Set<string>();
  const pastDates: string[] = [];

  for (const workDate of workDates) {
    const normalized = normalizeWorkDate(workDate);
    if (seen.has(normalized) || !isPastWorkDate(normalized, now)) continue;
    seen.add(normalized);
    pastDates.push(normalized);
  }

  return pastDates;
}

export function confirmPastScheduleAssignments(workDates: string[], now: dayjs.ConfigType = dayjs()): boolean {
  const pastDates = getPastWorkDates(workDates, now);
  if (pastDates.length === 0) return true;

  if (pastDates.length === 1) {
    const formattedDate = dayjs(pastDates[0]).format('MMM D, YYYY');
    return window.confirm(`You're about to add a schedule for ${formattedDate}, which is in the past. Continue?`);
  }

  return window.confirm(`You're about to add schedules that include ${pastDates.length} past dates. Continue?`);
}

export function confirmPastScheduleAssignment(workDate: string, now: dayjs.ConfigType = dayjs()): boolean {
  return confirmPastScheduleAssignments([workDate], now);
}
